enum SizeSmallMidLargeEnum {
  "SMALL" = 1,
  "MIDDLE" = 2,
  "LARGE" = 3,
  "XLARGE" = 4,
}

export default SizeSmallMidLargeEnum;
